export const TAX_ACCOUNTANT_USEFUL_SITES = [
  {
    list: [
      {
        label: "홈택스",
        link: "https://www.hometax.go.kr/websquare/websquare.html?w2xPath=/ui/pp/index_pp.xml"
      },
      {
        label: "위택스",
        link: "https://www.wetax.go.kr/main.do",
        // link: "https://www.wetax.go.kr/main/"
      },
      {
        label: "사회보험통합징수포털",
        link: "https://si4n.nhis.or.kr/jpza/JpZaa00101.do"
      },
      {
        label: "4insure",
        link: "https://www.4insure.or.kr/pbiz/main/main.do"
      },
      {
        label: "국세법령정보시스템",
        link: "https://taxlaw.nts.go.kr/index.do;jsessionid=YclCkfa-PNqXItZbBqVP95-PulzywnUUjiPtkaZt.cpesiwsp01_SE14"
      },
      {
        label: "이택스코리아",
        link: "https://www.etaxkorea.net/"
      },
      {
        label: "세무공무원 찾기",
        link: "https://www.etaxkorea.net/kacpta_k/main.php?tax_m1=3"
      },
      {
        label: "세무사 찾기",
        link: "https://www.kacpta.or.kr/kacpta_view/kac_taxbiz/taxAccountantSearch_n_Proc.asp"
      },

    ]
  },
  {
    list: [
      {
        label: "대법원인터넷등기소",
        link: "http://www.iros.go.kr/PMainJ.jsp"
      },
      {
        label: "개별공시지가",
        link: "https://www.realtyprice.kr/notice/gsindividual/siteLink.htm"
      },
      {
        label: "공동주택가격",
        link: "https://www.realtyprice.kr/notice/town/nfSiteLink.htm"
      },
      {
        label: "개별단독주택가격",
        link: "https://www.realtyprice.kr/notice/hpindividual/siteLink.htm"
      },
      {
        label: "토지대장",
        link: "https://www.gov.kr/mw/AA020InfoCappView.do?CappBizCD=13100000026&HighCtgCD=A02001001&tp_seq=01&Mcode=10207"
      },
      {
        label: "건축물대장",
        link: "https://www.gov.kr/mw/AA020InfoCappView.do?CappBizCD=15000000098&HighCtgCD=A02004002&tp_seq=01&Mcode=10205"
      },
      {
        label: "가족관계증명서",
        link: "https://efamily.scourt.go.kr/index.jsp"
      },
      {
        label: "주민등록등본",
        link: "https://www.gov.kr/mw/AA020InfoCappView.do?CappBizCD=13100000015&HighCtgCD=A01010001&tp_seq=01&Mcode=10200"
      },
      {
        label: "납세증명서",
        link: "https://www.gov.kr/mw/AA020InfoCappView.do?HighCtgCD=A09002&CappBizCD=12100000011&tp_seq=01"
      },
      {
        label: "지방세 납세증명서",
        link: "https://www.gov.kr/mw/AA020InfoCappView.do?CappBizCD=13100000056&HighCtgCD=A03019002&FAX_TYPE=y&img=02&tp_seq=01&Mcode=10209/"
      },
      {
        label: "양도코리아",
        link: "https://www.ydkorea.net/"
      },
    ],
  },

  {
    list: [{
      label: "세무연수원",
      link: "https://edu.kacpta.or.kr/main/index.jsp"
    },
    {
      label: "세무와 회계 연구",
      link: "https://www.kacpta.or.kr/education_view/tax_laboratory/labData_n.asp?bbs_idx=15"
    },
    {
      label: "조세도서관",
      link: "https://kacpta.egentouch.com/main.do?action=main&menuid=j1_2"
    },
    {
      label: "Dbpia",
      link: "https://kacpta.egentouch.com/main.do?action=main&menuid=j1_2"
    },
    {
      label: "KISS",
      link: "https://kacpta.egentouch.com/main.do?action=main&menuid=j1_2"
    },
    {
      label: "한국조세재정연구원",
      link: "https://www.kipf.re.kr/kor/"
    },
    {
      label: "한국세법학회",
      link: "https://tax-asso.or.kr/"
    },
    {
      label: "한국조세법학회",
      link: "http://www.kstl.kr/"
    },
    {
      label: "한국세무학회",
      link: "http://www.koreataxation.org/"
    },
    {
      label: "한국조세연구포험",
      link: "http://taxforum.or.kr/"
    },
    {
      label: "한국지방세연구원",
      link: "https://www.kilf.re.kr/"
    },
    {
      label: "한국지방세학회",
      link: "http://www.klota.or.kr/"
    },
    {
      label: "한국회계학회",
      link: "https://www.kaa-edu.or.kr/"
    },
    {
      label: "한국회계정책학회",
      link: "http://www.kasa2002.com/"
    },
    {
      label: "일본세무연구센터",
      link: "https://www.jtri.or.jp/"
    },


    {
      label: "한국세무사회",
      link: "https://edu.kacpta.or.kr/main/index.jsp"
    },
    {
      label: "한국세무사고시회",
      link: "http://www.gosihoi.co.kr/"
    },

    ]
  },


  {
    list: [
      {
        label: "국세청",
        link: "https://nts.go.kr/"
      },
      {
        label: "기획재정부",
        link: "https://www.moef.go.kr/"
      },
      {
        label: "조세심판원",
        link: "https://www.tt.go.kr/main/main.do"
      },
      {
        label: "법제처",
        link: "https://www.moleg.go.kr/"
      },
      {
        label: "대법원",
        link: "https://www.scourt.go.kr/scourt/index.html"
      },
      {
        label: "중소벤처기업부",
        link: "https://www.mss.go.kr/site/smba/main.do"
      },
      {
        label: "특허청",
        link: "https://www.kipo.go.kr/ko/MainApp.do"
      },
      {
        label: "일본세리사연합회",
        link: "https://www.nichizeiren.or.jp/"
      },
      {
        label: "일본세리사협동조합연합회",
        link: "http://www.nichizei.or.jp/"
      },
      {
        label: "비즈인포",
        link: "https://www.bizinfo.go.kr/web/index.do;jsessionid=XKXnMNi1JU72IR8avjluCzWFn88RQOiIOvVhibnkF6dOid0lnKJwKNZuIMufHlSI.ims_bizwas2_servlet_engine1"
      },
      {
        label: "기업정보공시",
        link: "https://dart.fss.or.kr/"
      },
      {
        label: "키프리스",
        link: "http://www.kipris.or.kr/khome/main.jsp"
      },
    ]
  },






]